import React, { useEffect, useMemo, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "../../components/Card/Card";
import CardHeader from "../../components/Card/CardHeader";
import CardBody from "../../components/Card/CardBody";
import GridItem from "../../components/Grid/GridItem";
import styles from "assets/jss/material-dashboard-pro-react/views/chartsStyle.js";
import { useSelector } from "react-redux";
import GridContainer from "../../components/Grid/GridContainer";

import {
  getInsuranceApplicantData,
  getLeadData,
  getSkillAssessmentData,
  getStudentData,
  getVisaApplicantData,
  useSetPaginationStateChange,
} from "../../scripts/util";
import CardIcon from "../../components/Card/CardIcon";
import ContactPhoneIcon from "@material-ui/icons/ContactPhone";
import { Pie } from "react-chartjs-2";
import SchoolIcon from "@material-ui/icons/School";
import DescriptionIcon from "@material-ui/icons/Description";
import WorkIcon from "@material-ui/icons/Work";
import HospitalIcon from "@material-ui/icons/LocalHospital";
import {
  BarElement,
  CategoryScale,
  Chart,
  LinearScale,
  Legend,
  ArcElement,
  PointElement,
  LineElement,
} from "chart.js";
import MonthYearSelector from "components/MonthYearSelector/MonthYearSelector";
import moment from "moment-timezone";
import { useGetLeads } from "api/lead";
import { useGetStudent } from "api/student";
import { useGetVisaApplicants } from "api/visaApplicant";
import { useGetSkillAssesment } from "api/skillAssesment";
import { useGetInsuranceApplicant } from "api/insuraceApplicant";
const useStyles = makeStyles(styles);

const CountPieChart = () => {
  Chart.register(
    ArcElement,
    PointElement,
    LinearScale,
    CategoryScale,
    BarElement,
    Legend,
    LineElement
  );
  const classes = useStyles();
  const { onPageChange, onPageSizeChange, onHandleDateRangeFilter } =
    useSetPaginationStateChange();

  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");

  const [skillSelectedMonth, setSkillSelectedMonth] = useState("");
  const [skillSelectedYear, setSkillSelectedYear] = useState("");

  const [insuranceSelectedMonth, setInsuranceSelectedMonth] = useState("");
  const [insuranceSelectedYear, setInsuranceSelectedYear] = useState("");

  const [visaSelectedMonth, setVisaSelectedMonth] = useState("");
  const [visaSelectedYear, setVisaSelectedYear] = useState("");

  const [studentSelectedMonth, setStudentSelectedMonth] = useState("");
  const [studentSelectedYear, setStudentSelectedYear] = useState("");

  const { data: leadData, isLoading: leadsFetching } = useGetLeads();
  const leads = leadData?.rows || [];
  const { data: studentData, isLoading: studentsFetching } = useGetStudent();
  const students = studentData?.rows || [];

  const { data: visaApplicantData, isLoading: visaApplicantFetching } =
    useGetVisaApplicants();
  const visaApplicants = visaApplicantData?.rows || [];

  const { data: skillAssessmentData, isLoading: skillAssessmentFetching } =
    useGetSkillAssesment();
  const skillAssessments = skillAssessmentData?.rows || [];

  const {
    data: insuranceApplicantData,
    isLoading: insuranceApplicantFetching,
  } = useGetInsuranceApplicant();
  const insuranceApplicants = insuranceApplicantData?.rows || [];

  const insuranceApplicantDataForPie = useMemo(
    () => getInsuranceApplicantData(insuranceApplicants),
    [insuranceApplicants]
  );
  const skillAssessmentsDataForPie = useMemo(
    () => getSkillAssessmentData(skillAssessments),
    [skillAssessments]
  );
  const visaApplicantsDataForPie = useMemo(
    () => getVisaApplicantData(visaApplicants),
    [visaApplicants]
  );
  const studentDataForPie = useMemo(() => getStudentData(students), [students]);
  const leadDataForPie = useMemo(() => getLeadData(leads), [leads]);
  useEffect(() => {
    if (selectedMonth && selectedYear) {
      const now = new Date();
      const date = new Date(`${selectedYear}-${selectedMonth}-01`);
      onHandleDateRangeFilter(
        moment(date).format("YYYY-MM-DD"),
        moment(now).format("YYYY-MM-DD")
      );
    }
  }, [selectedMonth, selectedYear]);

  useEffect(() => {
    if (skillSelectedMonth && skillSelectedYear) {
      const now = new Date();
      const date = new Date(`${skillSelectedYear}-${skillSelectedMonth}-01`);
      onHandleDateRangeFilter(
        moment(date).format("YYYY-MM-DD"),
        moment(now).format("YYYY-MM-DD")
      );
    }
  }, [skillSelectedMonth, skillSelectedYear]);

  useEffect(() => {
    if (visaSelectedMonth && visaSelectedYear) {
      const now = new Date();
      const date = new Date(`${visaSelectedYear}-${visaSelectedMonth}-01`);
      onHandleDateRangeFilter(
        moment(date).format("YYYY-MM-DD"),
        moment(now).format("YYYY-MM-DD")
      );
    }
  }, [visaSelectedMonth, visaSelectedYear]);

  useEffect(() => {
    if (insuranceSelectedMonth && insuranceSelectedYear) {
      const now = new Date();
      const date = new Date(
        `${insuranceSelectedYear}-${insuranceSelectedMonth}-01`
      );
      onHandleDateRangeFilter(
        moment(date).format("YYYY-MM-DD"),
        moment(now).format("YYYY-MM-DD")
      );
    }
  }, [insuranceSelectedMonth, insuranceSelectedYear]);

  useEffect(() => {
    if (studentSelectedMonth && studentSelectedYear) {
      const now = new Date();
      const date = new Date(
        `${studentSelectedYear}-${studentSelectedMonth}-01`
      );
      onHandleDateRangeFilter(
        moment(date).format("YYYY-MM-DD"),
        moment(now).format("YYYY-MM-DD")
      );
    }
  }, [studentSelectedMonth, studentSelectedYear]);
  return (
    <>
      <GridContainer>
        <GridItem xs={12} sm={12} md={4}>
          <Card>
            <CardHeader color="danger" icon>
              <GridContainer justifyContent="space-between" direction="row">
                <GridItem sx={6}>
                  <CardIcon color="danger">
                    <ContactPhoneIcon />
                  </CardIcon>
                  <h4 className={classes.cardIconTitle}>
                    Leads <small>in last 6 months</small>
                  </h4>
                </GridItem>
                <GridItem sx={6}>
                  <MonthYearSelector
                    selectedMonth={selectedMonth}
                    selectedYear={selectedYear}
                    onMonthChange={setSelectedMonth}
                    onYearChange={setSelectedYear}
                  />
                </GridItem>
              </GridContainer>
            </CardHeader>
            <CardBody>
              {leads?.length !== 0 && <Pie data={leadDataForPie} />}
            </CardBody>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={12} md={4}>
          <Card>
            <CardHeader color="danger" icon>
              <GridContainer justifyContent="space-between" direction="row">
                <GridItem sx={6}>
                  <CardIcon color="danger">
                    <SchoolIcon />
                  </CardIcon>
                  <h4 className={classes.cardIconTitle}>
                    Students <small>in last 6 months</small>
                  </h4>
                </GridItem>
                <GridItem sx={6}>
                  <MonthYearSelector
                    selectedMonth={studentSelectedMonth}
                    selectedYear={studentSelectedYear}
                    onMonthChange={setStudentSelectedMonth}
                    onYearChange={setStudentSelectedYear}
                  />
                </GridItem>
              </GridContainer>
            </CardHeader>
            <CardBody>
              {students.length !== 0 && <Pie data={studentDataForPie} />}
            </CardBody>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={12} md={4}>
          <Card>
            <CardHeader color="danger" icon>
              <GridContainer justifyContent="space-between" direction="row">
                <GridItem sx={6}>
                  <CardIcon color="danger">
                    <DescriptionIcon />
                  </CardIcon>
                  <h4 className={classes.cardIconTitle}>
                    Visa Applicants <small>in last 6 months</small>
                  </h4>
                </GridItem>
                <GridItem>
                  <MonthYearSelector
                    selectedMonth={visaSelectedMonth}
                    selectedYear={visaSelectedYear}
                    onMonthChange={setVisaSelectedMonth}
                    onYearChange={setVisaSelectedYear}
                  />
                </GridItem>
              </GridContainer>
            </CardHeader>
            <CardBody>
              {visaApplicants.length !== 0 && (
                <Pie data={visaApplicantsDataForPie} />
              )}
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={12} md={6}>
          <Card>
            <CardHeader color="danger" icon>
              <GridContainer justifyContent="space-between" direction="row">
                <GridItem sx={6}>
                  <CardIcon color="danger">
                    <WorkIcon />
                  </CardIcon>
                  <h4 className={classes.cardIconTitle}>
                    Skill Assessment <small>in last 6 months</small>
                  </h4>
                </GridItem>
                <GridItem>
                  <MonthYearSelector
                    selectedMonth={skillSelectedMonth}
                    selectedYear={skillSelectedYear}
                    onMonthChange={setSkillSelectedMonth}
                    onYearChange={setSkillSelectedYear}
                  />
                </GridItem>
              </GridContainer>
            </CardHeader>
            <CardBody>
              {skillAssessments.length !== 0 && (
                <Pie data={skillAssessmentsDataForPie} />
              )}
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={12} md={6}>
          <Card>
            <CardHeader color="danger" icon>
              <GridContainer justifyContent="space-between" direction="row">
                <GridItem sx={6}>
                  <CardIcon color="danger">
                    <HospitalIcon />
                  </CardIcon>
                  <h4 className={classes.cardIconTitle}>
                    Insurance Providers <small>in last 6 months</small>
                  </h4>
                </GridItem>
                <GridItem>
                  <MonthYearSelector
                    selectedMonth={insuranceSelectedMonth}
                    selectedYear={insuranceSelectedYear}
                    onMonthChange={setInsuranceSelectedMonth}
                    onYearChange={setInsuranceSelectedYear}
                  />
                </GridItem>
              </GridContainer>
            </CardHeader>
            <CardBody>
              {insuranceApplicants.length !== 0 && (
                <Pie data={insuranceApplicantDataForPie} />
              )}
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </>
  );
};

export default CountPieChart;
